import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasClickOutsideDirective } from './gas-click-outside.directive';

const DIRECTIVES = [
  GasClickOutsideDirective,
];

@NgModule({
  declarations: [
    DIRECTIVES,
  ],
  exports: [
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasClickOutsideDirectiveModule { }
